import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export function useClienteInfo(sessionId, schemaName) {
  const [clienteId, setClienteId] = useState(null);
  const [empresaId, setEmpresaId] = useState(null);
  const [esCorporativo, setEsCorporativo] = useState(false);
  const [sedes, setSedes] = useState([]);
  const [puedeCargarOrdenCompra, setPuedeCargarOrdenCompra] = useState(false);

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    axios
      .get(`${API_URL}/chat/cliente-info/${schemaName}/${sessionId}`)
      .then((res) => {
        if (!cancelled && res.data.status === 'success' && res.data.data) {
          setClienteId(res.data.data.id);
          if (res.data.data.empresa_id) setEmpresaId(res.data.data.empresa_id);
          setEsCorporativo(!!res.data.data.es_corporativo);
          setSedes(res.data.data.sedes || []);
          setPuedeCargarOrdenCompra(!!res.data.data.puede_cargar_orden_compra);
        }
      })
      .catch((e) => console.error('Error cargando info cliente:', e?.message || e));
    return () => { cancelled = true; };
  }, [sessionId, schemaName]);

  return { clienteId, empresaId, esCorporativo, sedes, puedeCargarOrdenCompra };
}
